export enum CapitalActionNoticeStatus {
  Draft = "draft",
  Published = "published",
}
